import React from "react";
import { Plus } from "react-bootstrap-icons";
import "./AddIcon.css";

const AddIconButton = ({
  setClickedContact,
  setPopupAdd,
  message,
  handleAddContact,
}) => {
  return (
    <Plus
      onClick={() => {
        handleAddContact(message);
        setClickedContact(message);
        setPopupAdd(true);
        // handleAddContact(message);
      }}
      className="add-icon-button" // Custom class for styling
      style={{ cursor: "pointer" }} // Ensures it looks clickable
      size={20} // Optional: set the size of the icon
    />
  );
};

export default AddIconButton;
